import React from 'react';
import TooltipItem from '../../common/Tooltip';
import Loader from '../../common/loader';
import { messages } from '../../common/messages';
const ProgressBar = ({
  headerName = '',
  tooltipContent = messages.YOU_CAN_SEE,
  tooltipPlace = 'left',
  ProgressBarData = [],
  progressBarLoader = true,
  ProgressBarTables = '',
  countKey = 'questionsCount',
}) => {
  let progressBarItem;
  const { questionModel, questionStatsModel } = ProgressBarTables;
 
  return (
    <div className='card'>
      <div className='card-header'>
        {headerName}
        <div className='card-actions card_action_tooltip float-right'>
          <TooltipItem
            key={headerName}
            tooltipId={headerName}
            content={tooltipContent}
            tooltipPlace={tooltipPlace}
          />
        </div>
      </div>
      <div className=''>
        <table className='table table-hover mb-0 compress_table'>
          {progressBarLoader ? (
            <div className='card-block-loader'>
              <Loader />
            </div>
          ) : (
            <tbody>
              {ProgressBarData.map((item, index) => {
                progressBarItem = Math.round(
                  (item[`${questionModel}.${questionStatsModel}.attemptCount`] /
                    item[`${questionModel}.${countKey}`]) *
                    100,
                );
                if (progressBarItem < 1) {
                  progressBarItem = 1;
                }
                return (
                  <tr key={index}>
                    <td>
                      <div className='question_row'>
                      <div className='question_count'>{`${headerName === 'Questions Progress' ? 'Q.' : 'N.'}${index + 1}`}</div>
                        <div className='question_bar'>
                          <p>{item.chapterName}</p>
                          <div className='bar_wrap'>
                            <div>
                              <div
                                className='progress progress-xs'
                                style={{ width: `${progressBarItem}%` }}
                              >
                                <div
                                  className='progress-bar bg-info'
                                  role='progressbar'
                                  aria-label={`${item.chapterName} progress`}
                                  aria-valuenow={progressBarItem}
                                  aria-valuemin={0}
                                  aria-valuemax={100}
                                  style={{ width: '100%' }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          )}
        </table>
      </div>
    </div>
  );
};
export default ProgressBar;



// WEBPACK FOOTER //
// ./src/Components-2025/dashboard/ProgressBar.jsx